// ----------------------------------------------------------------------

// Whether a student has an ASN that a /student/:asn link can be built from.
//
// PowerSchool has student records whose ASN is empty or a lone non-breaking
// space (#583). They reach the frontend as null, '' or '\u00a0', and a link built
// from one puts the literal 'null' or '%C2%A0' in the URL, which is what a route
// param holds when someone opens such a link. `trim` strips U+00A0 along with
// ordinary whitespace.
export function hasAsn(asn) {
  if (asn === null || asn === undefined) return false;
  const value = String(asn).trim();
  return value !== '' && value !== 'null' && value !== 'undefined';
}
